import { PersonSimpleRunIcon, type Icon as PhosphorIcon } from '@phosphor-icons/react';
import {
    Brain,
    Mountain,
    Watch,
    BarChart3,
    FileText,
    TrendingUp,
    type LucideIcon,
    HeartPulse,
    BicepsFlexed,
    ShieldUser,
    Anvil,
    BrainCog,
    BrainCircuit,
    Shapes,
    Boxes,
    WavesLadder,
    Award,
    Crosshair,
    Gauge,
    Radius,
    SquareActivityIcon,
    ShieldCheck,
    Video,
    AudioLines,
    File,
    Hash,
    Sprout,
    Waypoints,
    OctagonX,
    Flame,
    Grid2X2,
} from 'lucide-react';
import { ModuleCategory, ModuleSubCategory } from '@/gql/enums';
// Icon mapping for each groupingKey.
export const moduleIcons: Record<string, LucideIcon | PhosphorIcon> = {
    // Assessment - Cognitive
    sart: BrainCog,
    'visual-rxn': Shapes,
    'spatial-planning': Boxes,
    'digit-span': Hash,
    'adaptive-intelligence-test': Waypoints,
    'go-no-go': OctagonX,
    'concentration-grid': Grid2X2,
    // Assessment - Psychological
    'self-determination': Anvil,
    ml360: Radius,
    'ml360-self': Radius,
    'ml360-buddy': Radius,
    'ml360-trainer': Radius,
    'ml360-work': Radius,
    'ml360-work-self': Radius,
    'ml360-work-buddy': Radius,
    'ml360-work-trainer': Radius,
    'team-resilience': ShieldUser,
    'individual-motivation-questionnaire': Award,
    'individual-motivation-questionnaire-work': Award,
    'personal-coping-style': ShieldCheck,
    'growth-mindset': Sprout,
    'burnout-inventory': Flame,
    'organisational-ai-readiness': BrainCircuit,
    // Assessment - Physical
    'cardio-respiratory': HeartPulse,
    'strength-assessment': BicepsFlexed,
    ippt: Award,
    soc: PersonSimpleRunIcon,
    '20km-road-march': Mountain,
    'fin-swim': WavesLadder,
    bmp: Crosshair,
    weight: Gauge,

    // External Integration
    'polar-watch': Watch,
    vald: BarChart3,

    // Reporting
    'individual-report': FileText,
    'team-resilience-report': TrendingUp,
    'personal-coping-report': ShieldCheck,
    'inbody-composition': SquareActivityIcon,
    // Training and Nutrition content modules
    'content-video': Video,
    'content-audio': AudioLines,
    'content-pdf': File,
    'training-activity-concentration-grid': Grid2X2,
    'training-activity-digit-span': Hash,
};

export const getModuleIcon = (groupingKey: string): LucideIcon | PhosphorIcon => {
    return moduleIcons[groupingKey] || Brain; // Default fallback
};

export const getIconBackground = (category: ModuleCategory, subCategory?: ModuleSubCategory): string => {
    // For Assessment and Training modules, use subcategory colors
    if ((category === ModuleCategory.Assessment || category === ModuleCategory.Training) && subCategory) {
        switch (subCategory) {
            case ModuleSubCategory.Cognitive:
                return 'bg-teal-100 text-teal-500';
            case ModuleSubCategory.Psychological:
                return 'bg-blue-100 text-blue-500';
            case ModuleSubCategory.Physical:
                return 'bg-purple-100 text-purple-500';
            case ModuleSubCategory.BreathingTechniques:
                return 'bg-pink-100 text-pink-500';
            default:
                return 'bg-gray-100 text-gray-500';
        }
    }

    // For External Integration and Reporting modules, use category colors
    switch (category) {
        case ModuleCategory.External:
            return 'bg-yellow-100 text-yellow-500';
        case ModuleCategory.Reporting:
            return 'bg-indigo-100 text-indigo-500';
        case ModuleCategory.Nutrition:
            return 'bg-pink-100 text-pink-500';
        default:
            return 'bg-gray-100 text-gray-500';
    }
};
